import React, { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedDate as Date } from 'react-intl';

const FormattedDate = ({
  component: Wrapper = 'span',
  forwardedRef,
  timeZone,
  timeZoneName,
  value,
  ...props
}) => (
  <Date
    timeZone={timeZone}
    timeZoneName={timeZoneName}
    value={value}
    {...props}
  >
    {text => (
      <Wrapper {...props} ref={forwardedRef}>
        {text}
      </Wrapper>
    )}
  </Date>
);

FormattedDate.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
    PropTypes.string,
  ]),
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  timeZone: PropTypes.string,
  timeZoneName: PropTypes.string,
  value: PropTypes.any,
};

export default memo(
  // eslint-disable-next-line react/display-name
  forwardRef((props, forwardedRef) => (
    <FormattedDate {...props} forwardedRef={forwardedRef} />
  )),
);
